// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.option-group{padding:1.5rem 0}.option-group label{font-size:22px;font-weight:300}.option-group .checked-value{margin-top:8px}.option-group .checked-value label{font-size:20px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
